import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxsModule } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule, CoreModule } from './modules';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SimulationModule } from './modules/simulation';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, POSITION, SPINNER } from 'ngx-ui-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: '#17b978',
    bgsOpacity: 0.5,
    bgsSize: 60,
    bgsType: SPINNER.threeStrings,
    blur: 5,
    delay: 0,
    fastFadeOut: true,
    fgsColor: '#17b978',
    fgsPosition: POSITION.centerCenter,
    fgsSize: 60,
    fgsType: SPINNER.threeStrings,
    gap: 24,
    logoPosition: POSITION.centerCenter,
    logoSize: 120,
    logoUrl: '',
    masterLoaderId: 'master',
    overlayBorderRadius: '0',
    overlayColor: 'rgba(40, 40, 40, 0.8)',
    pbColor: '#17b978',
    pbDirection: 'ltr',
    pbThickness: 3,
    hasProgressBar: true,
    text: '',
    textColor: '#FFFFFF',
    textPosition: 'center-center',
    maxTime: -1,
    minTime: 300,
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        NgxSpinnerModule,
        AuthModule.forRoot(environment.api),
        NgxsModule.forRoot([], { developmentMode: !environment.production }),
        HttpClientModule,
        BrowserAnimationsModule,
        SimulationModule.forRoot(environment.api),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgxUiLoaderHttpModule.forRoot({
            showForeground: true,
            exclude: [
                // `${environment.api.endpoint}/Organizations`,
                `${environment.api.endpoint}/SimulationFeedback`,
                `${environment.api.endpoint}/Simulation/Gets`,
                `${environment.api.endpoint}/Simulation/Get`,
                `${environment.api.endpoint}/SimulationType/Gets`,
                `${environment.api.endpoint}/User/GetListUsers`,
                `${environment.api.endpoint}/SimulationFeedback/GetBySimulation`,
                `${environment.api.endpoint}/Participant/Gets`,
                `${environment.api.endpoint}/Participant/GetParticipantsOnline`,
            ],
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    bootstrap: [AppComponent],
    exports: [TranslateModule],
})
export class AppModule {}

export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
